import React, { useState } from "react";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import Icon from "semantic-ui-react/dist/es/elements/Icon";
import { Link } from "react-router-dom";
// import "./Navbar.scss";

const ProfileIconComponent = (props) => {
    const [profilePopOn, profileDropDownChange] = useState("hover");
    const privacyPolicyLink = "https://www.radarr.com/privacypolicy/";

    const getAccountOptions = () => {
        if (profilePopOn === "click")
            return (
                <>
                    <Link to="/profile" className="account">
                        <Icon name="user" size="small" />
                        <span className="account-text">Account</span>
                    </Link>
                    <a href={privacyPolicyLink} target="_blank" rel="noreferrer noopener" className="account">
                        <Icon name="file alternate" size="small" />
                        <span className="account-text">Privacy policy</span>
                    </a>
                    <Link to="/signout" className="account">
                        <Icon name="sign out" size="small" />
                        <span className="account-text">Sign Out</span>
                    </Link>
                </>
            );
        else return <span className="header-company-name">{props.userName + " - " + props.companyName}</span>;
    };

    return (
        <>
            <Popup
                className="accPopup skiptranslate"
                trigger={
                    <div className="profilePic profile_step1" onClick={() => profileDropDownChange("click")}>
                        <>
                            <img
                                src={props.profilePic ? props.profilePic : `${process.env.PUBLIC_URL}/profilePic.jpg`}
                                alt="Profile Photo"
                                className="home_step4"
                            />
                            {/* <img src={props.companyPic} alt="company Photo" /> */}
                        </>
                    </div>
                }
                on={profilePopOn}
                onClose={() => profileDropDownChange("hover")}
                content={getAccountOptions()}
                position="bottom right"
                hideOnScroll
                inverted={profilePopOn === "hover"}
                size={profilePopOn === "hover" ? "tiny" : "small"}
            />
        </>
    );
};

export default ProfileIconComponent;
